import styled from 'styled-components';

const ContactFromWrapper = styled.div`
  .box-container {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    z-index: 1;
    padding: 30px 10px;
    margin-bottom: 15px;
  }

  .text-content {
    font-weight: 600;
    font-size: 20px;
  }

  .btn-acc {
    padding: 10px 30px;
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
      #3546ee;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
  }

  @media (min-width: 768px) {
    .box-container {
      padding: 15px;
      margin-bottom: 20px;
    }
    .text-content {
      font-size: 28px;
    }

    .btn-acc {
      padding: 15px 50px;
      font-size: 15px;
    }
  }

  @media (min-width: 992px) {
    .box-container {
      padding: 30px;
      margin-bottom: 30px;
    }

    .text-content {
      font-size: 35px;
    }

    .btn-acc {
      padding: 30px 60px;
      font-size: 20px;
    }
  }
`;

export default ContactFromWrapper;
